'use strict';

var KeyMirror = require('keymirror');

var form = {
    cif: 0,
    oin: 0,
    kycFlag: false,
    gender: null,
    genderReadonly: null,
    title: null,
    titleReadonly: null,
    givenName: null,
    givenNameReadonly: null,
    lastName: null,
    lastNameReadonly: null,
    dateOfBirth: null,
    dateOfBirthReadonly: null,
    residentialAddress: null,
    postalAddress: null,
    contactDetails: {
        mobile: null,
        mobileReadonly: null,
        home: null,
        homeReadonly: null,
        work: null,
        workReadonly: null,
        email: null,
        emailReadonly: null,
        withExistingMobileNumber: null
    },
    tfnInfo: {
        tfnNumber: null,
        tfnNumberReadonly: null,
        tfnConsentFlag: null,
        tfnWithConsent: null,
        exemptionReason: null,
        exemptionReasonReadonly: null,
        hasTfnExemption: null
    },
    taxResidence: null,
    isAustralianResident: null,
    countryOfResidence: null,
    occupation: null,
    investorList: [],
    trusteeList: [],
    partnershipName: null,
    primaryBusinessActivity: null,
    primaryBusinessActivityReadonly: null,
    isCharity: null,
    isPrimaryBusinessInvesting: null,
    countryEstablished: null,
    abn: null,
    accountDesignation: {
        isAccountDesignation: null,
        accountDesignationName: null
    },
    abnReadonly: null,
    citizenship: null,
    businessName: null,
    businessNameReadonly: null,
    businessAddress: null,
    isPowerOfAttorney: null,
    isAustralianTaxResident: null,
    sourceOfFund: null,
    sourceOfWealth: null,
    otherSourceOfFund: null,
    otherSourceOfWealth: null,
    sourceOfFundDescription: null,
    sourceOfWealthDescription: null
};

var _gender = {
    MALE: 'M',
    FEMALE: 'F'
}

var labels = {
    gender: 'Gender',
    title: 'Title',
    givenName: 'Given name(s)',
    lastname: 'Last name',
    fullname: 'Full name',
    name: 'Name',
    dateOfBirth: 'Date of birth',
    residentialAddress: 'Residential address',
    sameResAddress: 'Same as residential address',
    companyAddress: 'Registered office address/principal place of business',
    businessAddress: 'Registered business address/principal place of business',
    sameBusinessAddress: 'Same as registered business address',
    sameCompanyAddress: 'Same as registered office address/principal place of business',
    postalAddress: 'Postal address',
    mobileNumber: 'Mobile number',
    homeNumber: 'Home phone number',
    workNumber: 'Work phone number',
    emailAddress: 'Email address',
    tfnInfo: {
        tfnNumber: 'Tax File Number (TFN)',
        TFN_PROVIDED: 'PROVIDED',
        NO_TFN_SUPPLIED: 'INCOMPLETE',
        exemptionReason: 'Exemption reason',
        isConsentReceived: 'Applicant consent received to reuse TFN',
        tfnExplicitConsent: 'SuperMatch TFN Consent'
    },
    abn: 'ABN/ARBN',
    abnInvestment: 'ABN/ARBN/ARSN',
    isAustralianResident: 'Permanent resident of Australia',
    countryOfResidence: 'Main country of residence',
    sourceOfFund: 'Source of funds',
    sourceOfWealth: 'Source of wealth',
    otherSourceOfFund: 'Other Source of funds',
    otherSourceOfWealth: 'Other Source of wealth',
    otherCountryTaxResidence: 'Country of residence for tax purposes',
    otherCountryTaxResidenceInvestment: 'Country of tax residence',
    citizenship1: 'Citizenship 1',
    citizenship2: 'Citizenship 2',
    occupation: 'Occupation',
    accountDesignation: {
        label: 'Account designation',
        NOT_PROVIDED: 'NOT PROVIDED'
    },
    kyc: {
        label: 'Know your customer (KYC)',
        KYC_PROVIDED: 'PROVIDED',
        KYC_INCOMPLETE: 'INCOMPLETE'
    },
    tin: {
        label: 'Tax identification number (TIN)',
        tinExemptionReason: 'TIN Exemption reason'
    },
    businessName: {
        T: 'Full name of trust',
        C: 'Full name of company',
        P: 'Full name of partnership',
        S: 'Full name of super fund'
    },
    business: {
        name: 'Full business name',
        abn: 'ABN (if any)',
        ABN_NOT_PROVIDED: 'NOT PROVIDED'
    },
    primaryBusinessActivity: {
        T: 'Primary trust activity',
        C: 'Primary business activity',
        P: 'Primary business activity',
        S: 'Primary trust activity'
    },
    primaryBusinessActivityInvesting: {
        T: 'Primary business activity investing',
        C: 'Primary business activity investing',
        P: 'Primary business activity investing',
        S: 'Primary business activity investing'
    },
    isCharity: 'Is this a charity',
    isCharityInvestment: 'Charity',
    countryEstablished: 'Country established',
    trustee: {
        corporateTrustee: 'Full name of corporate trustee',
        individualName: 'Full name',
        abnTrust: 'ABN/ACN',
        trusteeType: 'Trustee type'
    },
    address: {
        residential: {
            residence: 'Residential address',
            address1: 'Residential address line 1',
            address2: 'Residential address line 2',
            CityStatePostCode: 'City/State/Postcode',
            CitySuburb: 'City/Suburb',
            state: 'State',
            postcode: 'Postcode',
            country: 'Country',
            isResPostalAdd: 'Is this your postal address?'
        },
        business: {
            address1: 'Principal place of business address line 1',
            address2: 'Principal place of business address line 2',
            CityStatePostCode: 'City/State/Postcode',
            CitySuburb: 'City/Suburb',
            state: 'State',
            postcode: 'Postcode',
            country: 'Country',
            isResPostalAdd: 'Is this the postal address?'
        },
        company: {
            residence: 'Registered office address/principal place of business'
        },
        soleTrader: {
            residence: 'Full address of principal place of business'
        }
    },
    isPowerOfAttorney: {
        label: 'Power of Attorney',
        displayLabel: 'This application will be signed under a Power of Attorney'
    },
    isAustralianTaxResident: {
        label: 'Australian Tax Resident',
        displayLabel:'Are you a tax resident of Australia?'
    },
    fniCopyText: 'If you have changed any of your details, these may be updated when you submit this application. This includes the other accounts you hold with CFS.'
}

module.exports = {
    ActionTypes: KeyMirror({
        SAVE_TFN: null,
        SAVE_ADDRESS_INFO: null,
        SAVE_TFN_INFO: null,
        SAVE_BUSINESS_ADDRESS: null,
        RETRIEVE_YOUR_DETAILS: null,
        ADD_ADDITIONAL_INVESTORS: null,
        UPDATE_YOUR_DETAILS: null,
        YOUR_DETAILS_REMOVE_VALIDATION: null,
        DELETE_TRUSTEE: null,
        ADD_TRUSTEE: null
    }),
    GenderRadioData: [
        { id: _gender.MALE, name: 'Male', isHidden: false }, { id: _gender.FEMALE, name: 'Female', isHidden: false }
    ],
    Values: {
        GENDER_MALE: _gender.MALE,
        GENDER_FEMALE: _gender.FEMALE,
        ID_MOBILE: 'mobileNumber',
        ID_HOME: 'homeNumber',
        ID_WORK: 'workNumber',
        TEXT_MOBILE: 'mobile',
        TEXT_HOME: 'home',
        TEXT_WORK: 'work',
        TEXT_EMAIL: 'email',
        COUNTRY_AUSTRALIA: 'AU',
        COUNTRY_AUSTRALIA_LONG: 'Australia',
        COUNTRY_UNITED_STATES: 'US',
        COUNTRY_NEW_ZEALAND: 'NZ',
        FIRST_AND_MIDDLE_NAME_TOKEN: ' ',
        MORE: 'more',
        RESIDENTIAL: 'residential',
        BUSINESS: 'business',
        POSTAL: 'postal',
        ABN_LENGTH: 11,
        ACN_LENGTH: 9,
        REQUIRED_AU_RESIDENT: 'You must be in Australia to open this account',
        REQUIRED_AU_OR_NZ_RESIDENT:  'You must be in Australia (or New Zealand) to open this account'
    },
    ResidenceType: KeyMirror({
        TAX_RESIDENCE: null,
        COUNTRY_RESIDENCE: null,
        CITIZENSHIP: null
    }),
    AU_numbers: {
        Start_02: '02',
        Start_03: '03',
        Start_04: '04',
        Start_05: '05',
        Start_07: '07',
        Start_08: '08'
    },
    Properties: {
        Form: form,
        AddressInfo: {
            defineAddressLine: '',
            residential: '',
            isResAddressFound: false,
            resCountry: '',
            resCountryReadonly: false,
            address1: '',
            address2: '',
            addressLineReadonly: false,
            cityStatePostCode: '',
            cityStatePostCodeReadonly: false,
            resAusState: '',
            resAusStateReadonly: false,
            postCode: '',
            postCodeReadonly: false,
            isResPostalAdd: '',
            definePostalAddressLine: '',
            postal: '',
            isPostalAddressFound: false,
            postalCountry: '',
            postalAddress1: '',
            postalAddress2: '',
            postalCityStatePostCode: '',
            postalAusState: '',
            postalPostCode: ''
        }
    },


    // for unit testing
    contactMobile: {
        mobileNumber: ''
    },
    //for unit testing
    tfnNumbers: {
        tfnNumber: ''
    },
    Validations: {
        // for save, only giveName and lastName are required
        personalInfoSave: {
            givenName: 'required',
            lastName: 'required'
        },
        businessSave: {
            businessName: 'required'
        },
        personalInfo: {
            gender: 'required',
            title: 'required|title',
            givenName: 'required|firstCharIsNotAlpha|givenName|maxLength:34',
            lastName: 'required|firstCharIsNotAlpha|givenName|maxLength:36',
            dateOfBirth: 'required|dateInvalidFormat|dateIsInvalid' //Add minimum age validation per product
        },
        contactDetails: {
            mobileNumber: 'mobileNumber|digitExactLength:10',
            homeNumber: 'landLineNumber|digitExactLength:10',
            workNumber: 'workPhoneNumber|digitExactLength:10',
            emailAddress: 'email|maxLength:60'
        },
        tfn: {
            tfnNumber: 'required|tfnExactLength|tfn',
            tfnWithConsent: 'tfnExactLength|tfn',
            tfnConsentFlag: 'required',
            tfnExemptionReason: 'required'
        },
        countryResidence: {
            isAustralianResident: 'required',
            countryOfResidence: 'required'
        },
        taxResident: {
            isOtherCountryTaxResident: 'required',
            otherCountryTaxResidence1: 'required',
            otherCountryTaxResidence2: 'required',
            otherCountryTaxResidence3: 'required',
            tin1: 'required|tin',
            tin2: 'required|tin',
            tin3: 'required|tin',
            tinExemptionReason1: 'required',
            tinExemptionReason2: 'required',
            tinExemptionReason3: 'required',
            hasTinExemptionReason1: 'required',
            hasTinExemptionReason2: 'required',
            hasTinExemptionReason3: 'required'
        },
        occupation: {
            occupation: 'required|maxLength:30'
        },
        citizenship: {
            isCitizenOfOtherCountry: 'required',
            citizenship1: 'required'
        },
        partnership: {
            partnershipName: 'required|maxLength:36'
        },
        business: {
            businessName: 'required|maxLength:36',
            primaryBusinessActivity: 'required|maxLength:30',
            isCharity: 'required',
            isPrimaryBusinessInvesting: 'required',
            countryEstablished: 'required'
        },
        abn: {
            abn: 'digitExactLength:11|abn'
        },
        abnAcn: {
            abn: 'digitExactLength:11|abnAcn'
        },
        address: {
            residential: 'required|addressIsPoBox',
            address1: 'required|maxLength:30|addressIsPoBox',
            address2: 'maxLength:30',
            cityStatePostCode: 'required|maxLength:20',
            resCountry: 'required',
            resAusState: 'required',
            postCode: 'required|isDigit:4|digitExactLength:4'
        },
        postalAddress: {
            isResPostalAdd: 'required',
            postal: 'required',
            postalAddress1: 'required|maxLength:30',
            postalAddress2: 'maxLength:30',
            postalCityStatePostCode: 'required|maxLength:20',
            postalCountry: 'required',
            postalAusState: 'required',
            postalPostCode: 'required|isDigit:4|digitExactLength:4'
        },
        accountDesignation: {
            accountDesignationName: 'maxLength:30'
        },
        AustralianTaxResident:{
            isAustralianTaxResident :'required'
        },
        sourceOfFund: {
            sourceOfFund: 'required|sofsowMaxOption',
            otherSourceOfFund: 'required|maxLength:35'
        },
        sourceOfWealth: {
            sourceOfWealth: 'required|sofsowMaxOption',
            otherSourceOfWealth: 'required|maxLength:35'
        }
    },
    MappingConfigurations: {
        Title: {
            popular: 'isHidden',
            valueMapper: function (key, value) {
                if (key == 'isHidden') {
                    return !value;
                }
            }
        },
        Country: {
            code: 'value',
            name: 'label'
        },
        //Note: we cannot use Code because it's not unique but we are sending Code to FMS so we need to map Id to Code in the Edge Api on Submission
        TfnExemption: {
            id: 'value',
            name: 'label'
        },
        ResidentialAddressSave: {
            residential: 'address',
            address1: 'address1',
            address2: 'address2',
            addressLineReadonly: 'addressLineReadonly',
            cityStatePostCode: 'cityStatePostCode',
            cityStatePostCodeReadonly: 'cityStatePostCodeReadonly',
            resCountry: 'country',
            resCountryReadonly: 'countryReadonly',
            resAusState: 'australiaState',
            resAusStateReadonly: 'australiaStateReadonly',
            postCode: 'postCode',
            postCodeReadonly: 'postCodeReadonly',
            isResAddressFound: 'isResAddressFound'
        },
        PostalAddressSave: {
            isResPostalAdd: 'isSameAsResidentialAddress',
            postal: 'address',
            postalAddress1: 'address1',
            postalAddress2: 'address2',
            postalCityStatePostCode: 'cityStatePostCode',
            postalCountry: 'country',
            postalAusState: 'australiaState',
            postalPostCode: 'postCode',
            isPostalAddressFound: 'isPostalAddressFound'
        },
        TaxResidenceSave: {
            isOtherCountryTaxResident: 'isOtherCountryTaxResident',
            isOtherCountryTaxResidentReadonly: 'isOtherCountryTaxResidentReadonly'
        },
        CitizenshipSave: {
            isCitizenOfOtherCountry: 'isCitizenOfOtherCountry',
            isCitizenOfOtherCountryReadonly: 'isCitizenOfOtherCountryReadonly',
            citizenship1: 'citizenship1',
            citizenship1Readonly: 'citizenship1Readonly',
            citizenship2: 'citizenship2',
            citizenship2Readonly: 'citizenship2Readonly'
        },
        OccupationSave: {
            occupation: 'occupation',
            occupationReadonly: 'occupationReadonly'
        },
        ContactSave: {
            mobileNumber: 'mobile',
            mobileNumberReadonly: 'mobileReadonly',
            homeNumber: 'home',
            homeNumberReadonly: 'homeReadonly',
            workNumber: 'work',
            workNumberReadonly: 'workReadonly',
            emailAddress: 'email',
            emailAddressReadonly: 'emailReadonly',
            withExistingMobileNumber: 'withExistingMobileNumber'
        },
        TfnSave: {
            tfnNumber: 'tfnNumber',
            tfnNumberReadonly: 'tfnNumberReadonly',
            exemptionReason: 'exemptionReason',
            exemptionReasonReadonly: 'exemptionReasonReadonly',
            hasTfnExemption: 'hasTfnExemption'
        },
        CountryOfResidenceSave: {
            isAustralianResident: 'isAustralianResident',
            isAustralianResidentReadonly: 'isAustralianResidentReadonly',
            countryOfResidence: 'country',
            countryOfResidenceReadonly: 'countryReadonly'
        },
        BusinessPostalAddressSave: {
            isResPostalAdd: 'isSameAsBusinessAddress',
            postal: 'address',
            postalAddress1: 'address1',
            postalAddress2: 'address2',
            postalCityStatePostCode: 'cityStatePostCode',
            postalCountry: 'country',
            postalAusState: 'australiaState',
            postalPostCode: 'postCode',
            isPostalAddressFound: 'isPostalAddressFound'
        },
        Products: {
            id: 'value',
            description: 'label'
        },
        isAustralianTaxResident: 'isAustralianTaxResident',
        sourceOfFund: {
            code: 'value',
            description: 'label'
        },
        sourceOfWealth:
        {
            code: 'value',
            description: 'label'
        }
    },
    InvestorType: KeyMirror({
        INVESTOR: null,
        TRUSTEE: null
    }),
    TrusteeType: {
        INDIVIDUAL: 'i',
        CORPORATE: 'c'
    },
    TrusteeTypeData: [{ id: 'i', name: 'Individual', isHidden: false }, { id: 'c', name: 'Corporate', isHidden: false }],
    AddTrusteeData: [{ id: 't', name: '+ Add trustee', isHidden: false }],
    AddInvestorData: [{ id: 'i', name: '+ Add investor', isHidden: false }],
    AddIndividualData: [{ id: 'i', name: '+ Add individual', isHidden: false }],
    Labels: labels,
    TinExemtionReasonData: [
        { value: 'A', label: 'The country of tax residency does not issue TINs to tax residents' },
        { value: 'B', label: 'The individual has not been issued with a TIN' },
        { value: 'C', label: 'The country of tax residency does not mandate provision of the TIN' }
    ],
    ExistingCustomerReadonlyFields: ['dateOfBirthReadonly', 'givenNameReadonly', 'lastNameReadonly',
    'mobileNumberReadonly', 'homeNumberReadonly', 'workNumberReadonly', 'occupationReadonly', 'emailAddressReadonly']
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/YourDetailsConstants.js